import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#F24653',
        secondary: '#5D647C',
        accent: '#77B2E8',
        error: '#F24653', // WAS F7CD66
        info: '#5D647C',
        success: '#0A9E65', // was #75eabd, but was not AA compliant against app background
        warning: '#9D6E00', // was #F7CD66, but was not AA compliant against app background
        anchor: 'var(--v-primary-darken1, #D2233C)', // darken for AA compliance against app background
      },
    },
    options: {
      customProperties: true,
    },
  },
});

export default vuetify;
